import { createApp } from 'vue'
import StafetDonationTaendLysStepTwo from './StafetDonationTaendLysStepTwo'

const el = '.kb-component--stafet-donation-taend-lys-step-two'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationTaendLysStepTwoDOM) => {
            const component = createApp(StafetDonationTaendLysStepTwo).use(
                Store
            )
            component.mount(StafetDonationTaendLysStepTwoDOM)
        })
    }
}
